<div
   class="outer-container"
   *ngIf="isDVMToolAdmin">
   <div
      class="pageHeader-row"
      [class.roster-top]="activeTeamSubTab === 'roster'">
      <div
         class="pageHeader-text"
         [style.max-width]="activeTeamSubTab === 'reviews' ? '430px' : '580px'">
         <div class="pre-heading">{{ reviewType == "OPEN" ? "OPEN CYCLE" : getRevieweeLabel() }}</div>
         <div class="heading">Performance Hub</div>
         <div
            class="subtext"
            *ngIf="activeTeamSubTab === 'reviews'">
            Please select a {{ reviewType == "OPEN" ? "user" : getRevieweeLabel() }} from the list below to begin their performance review.
         </div>
         <div
            class="subtext"
            *ngIf="activeTeamSubTab === 'roster'">
            Select a
            <span style="font-weight: 600">Review Type</span>
            and assign any
            <span style="font-weight: 600">Additional Responsibilities</span>
            for each team member below in your home hospital. Once completed, the team member's performance review will be opened and available for
            both the Team Member and HM to complete.
         </div>
      </div>

      <div
         class="pageHeader-filters"
         [style.margin-top]="activeTeamSubTab === 'roster' ? '-22px' : '0px'">
         <button
            type="button"
            class="v-button v-button-md v-green mr-1"
            style="padding-left: 6px; padding-right: 6px; padding-top: 5px; height: 43px; font-size: 13px"
            (click)="modals.openExportModal()"
            alt="Export List"
            title="Export List">
            <i class="fa fa-arrow-up-from-bracket"></i>
            <br />
            <div style="font-size: 8px; letter-spacing: 1px; margin-top: 3px">ROSTER</div>
         </button>
         <button
            type="button"
            class="v-button v-button-md v-green mr-1"
            style="padding-left: 6px; padding-right: 6px; padding-top: 5px; height: 43px; font-size: 13px"
            (click)="modals.exportHospitalStatusXlsx()"
            alt="Export Progress"
            title="Export Hospital Progress">
            <i class="fa fa-arrow-up-from-bracket"></i>
            <br />
            <div style="font-size: 8px; letter-spacing: 1px; margin-top: 3px">STATUS</div>
         </button>

         <vc-single-select-dropdown
            class="mr-1 dvm-drop"
            [items]="practiceOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="v-sitefilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by Hospital'"
            [disabled]="reviewType == 'DO' || reviewType == 'RM' ? true : false"
            [filter]="true"
            [setValue]="selectedPractice"
            (selectionChange)="onPracticeChange($event)"></vc-single-select-dropdown>

         <vc-single-select-dropdown
            *ngIf="reviewType != 'DVM' && reviewType != 'COS' && reviewType != 'OPEN'"
            class="mr-1 dvm-drop"
            [items]="reviewerNameOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="v-userfilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by ' + getReviewerLabel(true)"
            [filter]="true"
            [setValue]="selectedReviewerName"
            (selectionChange)="onReviewerChange($event)"></vc-single-select-dropdown>

         <vc-single-select-dropdown
            *ngIf="reviewType == 'DVM' || reviewType == 'COS' || reviewType == 'OPEN'"
            class="mr-1 dvm-drop"
            [items]="rmOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="v-userfilter"
            sizeClass="v-dropdown-sm"
            [placeholder]="'Filter by RM'"
            [filter]="true"
            [setValue]="selectedRMName"
            (selectionChange)="onRMChange($event)"></vc-single-select-dropdown>

         <div class="v-searchbox-sm v-userfilter mr-1">
            <vc-text-input
               type="text"
               (ngModelChange)="onNameSearch($event)"
               [(ngModel)]="searchName"
               placeholder="Search by name..."></vc-text-input>
         </div>

         <vc-single-select-dropdown
            *ngIf="activeTeamSubTab === 'reviews'"
            class="dvm-drop allStatus-drop"
            [items]="statusOptions"
            [optionLabel]="'label'"
            [optionValue]="'value'"
            variantClass="none"
            sizeClass="v-dropdown-xs"
            [placeholder]="'Status: Show all'"
            [filter]="false"
            [showClear]="false"
            [setValue]="selectedStatus"
            (selectionChange)="onStatusChange($event)"></vc-single-select-dropdown>
      </div>

      <div
         class="chips-row c-roster"
         *ngIf="activeTeamSubTab === 'roster'">
         <span class="chips-label">Review Type</span>
         <mat-chip-listbox
            multiple
            [(ngModel)]="selectedRT"
            (change)="onRTChange($event)">
            <mat-chip-option value="null">All Types</mat-chip-option>
            <mat-chip-option value="CLINICAL">Clinical</mat-chip-option>
            <mat-chip-option value="CROSSTRAINED">Cross-Trained</mat-chip-option>
            <mat-chip-option value="RECEPTION">Reception</mat-chip-option>
            <mat-chip-option value="">Unset</mat-chip-option>
         </mat-chip-listbox>
      </div>

      <div
         class="chips-row c-reviews"
         *ngIf="activeTeamSubTab === 'reviews'">
         <span class="chips-label">{{ getRevieweeLabel(false) + "s " }}</span>
         <mat-chip-listbox
            multiple
            [(ngModel)]="selectedDeferredFilters"
            (change)="onDeferredChipChange($event)">
            <mat-chip-option value="null">Show All</mat-chip-option>
            <mat-chip-option value="active">Active</mat-chip-option>
            <mat-chip-option value="deferred">Deferred</mat-chip-option>
            <mat-chip-option value="LOAINACTIVE">On Leave</mat-chip-option>
         </mat-chip-listbox>
      </div>
   </div>

   <!-- Cycle closed notice -->
   <div
      *ngIf="!isCurrentCycleOpen"
      class="cycle-closed-notice">
      <i class="fa fa-lock cycle-closed-notice__icon"></i>
      <div class="cycle-closed-notice__body">
         <span class="cycle-closed-notice__title">Team Member performance reviews are currently closed -</span>
         <span class="cycle-closed-notice__reason">{{ currentCycleClosedReason }}</span>
      </div>
   </div>

   <div
      class="cycle-tabs-row"
      [style.margin-top]="activeTeamSubTab === 'roster' ? '0px' : '0px'">
      <button
         class="cycle-tab"
         [class.cycle-tab--active]="activeTeamSubTab === 'roster'"
         (click)="setTeamSubTab('roster')">
         <i
            class="fas fa-clipboard-user"
            style="font-size: 18px; margin-right: 3px"></i>
         Team Member Roster
      </button>
      <button
         class="cycle-tab"
         [class.cycle-tab--active]="activeTeamSubTab === 'reviews'"
         (click)="setTeamSubTab('reviews')">
         <i
            class="fas fa-users"
            style="font-size: 18px; margin-right: 3px"></i>
         Team Member Reviews
      </button>
   </div>

   <div class="main-app-container">
      <div *ngIf="activeTeamSubTab === 'reviews'">
         <vc-spinner *ngIf="!isUserReviewsLoaded || !isPlansLoaded"></vc-spinner>
         <div
            *ngIf="isUserReviewsLoaded && isPlansLoaded"
            class="table-container"
            [class.table-container--read-only]="!isCurrentCycleOpen">
            <table
               matSort
               (matSortChange)="sortData($event)">
               <thead>
                  <tr class="columnHeaders">
                     <th mat-sort-header="name">
                        {{ getRevieweeLabel() }}
                     </th>
                     <th
                        mat-sort-header="practice"
                        style="max-width: 300px">
                        Hospital
                     </th>
                     <th
                        mat-sort-header="dvmSubmittedOn"
                        style="white-space: nowrap; min-width: 140px; max-width: 140px">
                        {{ getRevieweeLabel(true) }} Submitted
                     </th>
                     <th
                        mat-sort-header="cosSubmittedOn"
                        style="padding-left: 5px; white-space: nowrap; min-width: 125px; max-width: 125px">
                        {{ getReviewerLabel(true) }} Submitted
                     </th>
                     <th
                        [mat-sort-header]="(getReviewerLabel(true) | lowercase) + 'Name'"
                        style="padding-left: 5px">
                        {{ getReviewerLabel(true) }}
                     </th>
                     <th
                        [mat-sort-header]="'cosName'"
                        style="padding-left: 10px">
                        COS
                     </th>
                     <th
                        mat-sort-header="reviewType"
                        style="padding-left: 0px">
                        Review Type
                     </th>
                     <th
                        mat-sort-header="status"
                        style="min-width: 70px; padding-left: 0px; padding-right: 5px">
                        Status
                     </th>
                     <th
                        class="defer-col-header"
                        style="padding-left: 5px">
                        {{ isReportingAdmin() ? "" : "Deferred" }}
                     </th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngIf="dashboardRows.length < 1">
                     <td
                        colspan="9"
                        style="text-align: center">
                        You have no {{ getRevieweeLabel() }}s to review
                     </td>
                  </tr>

                  <tr
                     *ngFor="let row of pagedRows; let i = index; trackBy: trackByReviewee"
                     [class.tr-reviews-class]="activeTeamSubTab === 'reviews'"
                     [class.alternate]="i % 2 !== 0"
                     [class.row-deferred]="row._deferred || row._onLeave"
                     [class.row-read-only]="readOnlyMode"
                     (click)="onRowClick(row)"
                     style="vertical-align: -webkit-baseline-middle">
                     <td style="text-wrap-mode: nowrap; min-width: 165px; max-width: 165px">
                        <a
                           class="review-row-link"
                           style="color: #55585a"
                           [routerLink]="row.reviewType ? ['/performance-hub/team-reviews', row.revieweeId] : null"
                           [queryParams]="row.reviewType ? { rt: row.reviewType } : null"
                           (click)="row.reviewType && $event.stopPropagation()">
                           {{ row.name }}
                           <span *ngIf="row.hasAttachment">
                              &nbsp;
                              <i
                                 class="fa fa-paperclip"
                                 style="font-size: 12px; color: #505050"></i>
                           </span>
                           <span
                              *ngIf="row._deferred"
                              class="deferred-badge"
                              tooltipstyleclass="pims-tooltip"
                              [pTooltip]="row.deferReason"
                              style="padding-bottom: 1px; margin-left: 0px; margin-top: 0px">
                              <i class="fa fa-clock"></i>
                              Deferred
                           </span>
                           <span
                              *ngIf="row._onLeave"
                              class="deferred-badge"
                              style="margin-left: 0px; margin-top: 0px">
                              <i class="fa fa-user-alt"></i>
                              On leave
                           </span>
                        </a>
                     </td>

                     <td style="max-width: 190px; min-width: 190px; padding-right: 5px">{{ row.practice ? row.practice : "---" }}</td>

                     <td style="min-width: 140px; max-width: 140px; padding-right: 5px">
                        <span [class.incomplete-status-badge]="row._dvmIncomplete">
                           {{ row.dvmSubmittedOn || "INCOMPLETE" }}
                        </span>
                     </td>
                     <td style="min-width: 125px; max-width: 125px; padding-right: 5px; padding-left: 5px">
                        <span [class.incomplete-status-badge]="row._cosIncomplete">
                           {{ row.cosSubmittedOn || "INCOMPLETE" }}
                        </span>
                     </td>

                     <td style="min-width: 125px; max-width: 125px; padding-right: 5px; padding-left: 5px">
                        {{ row._reviewerName ? row._reviewerName : "---" }}
                        <span
                           *ngIf="row._newReviewerName && row._newReviewerName != row._reviewerName"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ row._newReviewerName }}
                        </span>

                        <span
                           *ngIf="row.hmName2 && row.hmName != row.hmName2 && row.newHM != row.hmName2"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ row.hmName2 }}
                        </span>
                     </td>

                     <td style="min-width: 145px; max-width: 145px; padding-right: 10px; padding-left: 5px">
                        {{ row.cosName ? row.cosName : "---" }}
                        <span
                           *ngIf="row.newCOS && row.newCOS != row.cosName"
                           style="padding-top: 2px; display: block; color: #959595; font-size: 11px; line-height: 14px">
                           <i
                              class="fa fa-arrow-turn-up"
                              style="transform: rotate(90deg)"></i>
                           &nbsp;Other: {{ row.newCOS }}
                        </span>
                     </td>

                     <td style="min-width: 110px; max-width: 110px; padding-left: 0px; padding-right: 5px">
                        <span
                           *ngIf="row.reviewType"
                           style="color: #232425; font-style: italic">
                           {{ row._reviewTypeLabel }}
                        </span>
                        <span
                           *ngIf="!row.reviewType"
                           style="color: #a8a8a8; font-style: italic; font-weight: 400">
                           UNSET
                        </span>
                     </td>

                     <td style="min-width: 130px; max-width: 130px; padding-right: 5px; padding-left: 0px">
                        <span
                           class="status-badge"
                           [class]="
                              row.isCompleted
                                 ? 'status-complete'
                                 : row.dvmSubmittedOn && row.cosSubmittedOn
                                   ? 'status-in-review'
                                   : !row.dvmSubmittedOn && !row.cosSubmittedOn && !row.hasStarted
                                     ? 'status-not-started'
                                     : 'status-pending'
                           ">
                           <i
                              [class]="
                                 row.isCompleted
                                    ? 'fa fa-check-circle completed-icon'
                                    : row.dvmSubmittedOn && row.cosSubmittedOn
                                      ? 'fa fa-user-group pending-icon'
                                      : !row.dvmSubmittedOn && !row.cosSubmittedOn && !row.hasStarted
                                        ? 'fa fa-circle-minus'
                                        : 'fa fa-hourglass-half in-progress-icon'
                              "></i>
                           {{
                              row.isCompleted
                                 ? "Completed"
                                 : row.dvmSubmittedOn && row.cosSubmittedOn
                                   ? "In Review"
                                   : !row.dvmSubmittedOn && !row.cosSubmittedOn && !row.hasStarted
                                     ? "Not Started"
                                     : "In Progress"
                           }}
                        </span>
                     </td>

                     <td
                        style="min-width: 65px; max-width: 65px; padding-left: 5px"
                        *ngIf="isReportingAdmin()"
                        class="defer-col"
                        (click)="$event.stopPropagation()">
                        <a
                           class="settings-nav-btn"
                           title="Manage user settings"
                           style="vertical-align: middle"
                           [href]="'./performance-hub/admin/user-management?userId=' + row.revieweeId + '&revieweeDisplayName=' + row.name + ''"
                           rel="noopener"
                           target="_blank">
                           <i class="fa fa-gear"></i>
                        </a>
                     </td>

                     <td
                        style="min-width: 155px; padding-left: 5px"
                        class="defer-col"
                        *ngIf="!isReportingAdmin()"
                        (click)="$event.stopPropagation()">
                        <!-- No deferral yet: show Request Deferral button -->
                        <button
                           *ngIf="!row.deferralStatus || row.deferralStatus == 'ReEnabled' || row.deferralStatus == 'Rejected'"
                           class="defer-btn"
                           style="position: relative"
                           [class.defer-btn-rejected]="row.deferralStatus == 'Rejected'"
                           (click)="row.deferralStatus == 'Rejected' ? modals.openRejectedDialog(row) : modals.openUserDeferDialog(row)">
                           <i
                              *ngIf="row.deferralStatus == 'Rejected'"
                              class="fa fa-close"
                              style="margin-right: 5px; margin-top: 2px"></i>
                           {{ row.deferralStatus == "Rejected" ? "Rejected" : "Request Deferral" }}
                           <span
                              *ngIf="row.deferralStatus == 'Rejected'"
                              class="fu-unread-badge">
                              1
                           </span>
                        </button>

                        <a
                           href="javascript:void(0);"
                           *ngIf="row.deferralStatus == 'Rejected'"
                           style="display: block; text-decoration: underline; font-size: 11px; color: #333333"
                           (click)="modals.openUserDeferDialog(row)">
                           Request again?
                        </a>

                        <button
                           *ngIf="(row.hasPendingDeferralRequest || row.deferralStatus == 'Pending') && (!row.hasAdminFollowUp || row._unread < 1)"
                           class="defer-btn defer-btn-requested"
                           [disabled]="true">
                           <i
                              class="fa fa-hourglass"
                              style="font-size: 11px; line-height: 18px"></i>
                           &nbsp; Requested
                        </button>

                        <button
                           *ngIf="(row.hasPendingDeferralRequest || row.deferralStatus == 'Pending') && row.hasAdminFollowUp && row._unread > 0"
                           class="defer-btn defer-btn-followup"
                           style="position: relative"
                           (click)="modals.openUserFollowUpDialog(row)">
                           <i
                              class="fa fa-comments"
                              style="font-size: 11px; line-height: 18px"></i>
                           &nbsp; Add Follow-up
                           <span
                              *ngIf="row._unread > 0"
                              class="fu-unread-badge">
                              {{ row._unread }}
                           </span>
                        </button>

                        <span
                           *ngIf="row.deferralStatus == 'Approved' || row.deferralStatus == 'Deferred'"
                           class="defer-na">
                           —
                        </span>
                     </td>
                  </tr>
               </tbody>
            </table>

            <!-- Pager -->
            <div
               class="table-pager"
               *ngIf="dashboardRows.length > pageSize">
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex === 0"
                  (click)="goToPage(0)"
                  title="First page">
                  <i class="fa fa-angles-left"></i>
               </button>
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex === 0"
                  (click)="goToPage(pageIndex - 1)"
                  title="Previous page">
                  <i class="fa fa-angle-left"></i>
               </button>
               <span class="table-pager__label">
                  Page
                  <input
                     type="number"
                     class="table-pager__input"
                     [value]="pageIndex + 1"
                     [min]="1"
                     [max]="totalPages"
                     (change)="goToPage(+$event.target.value - 1)" />
                  of {{ totalPages }} · {{ pageRangeStart }}–{{ pageRangeEnd }} of {{ dashboardRows.length }}
               </span>
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex >= totalPages - 1"
                  (click)="goToPage(pageIndex + 1)"
                  title="Next page">
                  <i class="fa fa-angle-right"></i>
               </button>
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex >= totalPages - 1"
                  (click)="goToPage(totalPages - 1)"
                  title="Last page">
                  <i class="fa fa-angles-right"></i>
               </button>
            </div>
         </div>
      </div>

      <!-- ROSTER TAB -->
      <div *ngIf="activeTeamSubTab === 'roster'">
         <vc-spinner *ngIf="!isUserReviewsLoaded || !isPlansLoaded"></vc-spinner>
         <div
            *ngIf="isUserReviewsLoaded && isPlansLoaded"
            class="table-container"
            [class.table-container--read-only]="!isCurrentCycleOpen">
            <table
               matSort
               (matSortChange)="sortData($event)">
               <thead>
                  <tr class="columnHeaders">
                     <th mat-sort-header="practice">
                        Hospital
                        <br />
                        Name
                     </th>
                     <th mat-sort-header="name">
                        Team
                        <br />
                        Member
                     </th>
                     <th mat-sort-header="hireDate">
                        Hire
                        <br />
                        Date
                     </th>
                     <th mat-sort-header="jobTitleCode">
                        Job
                        <br />
                        Role
                     </th>
                     <th mat-sort-header="jobTitle">
                        Job
                        <br />
                        Title
                     </th>
                     <th mat-sort-header="payClass">
                        Pay
                        <br />
                        Class
                     </th>
                     <!--<th [mat-sort-header]="(getReviewerLabel(true) | lowercase) + 'Name'">
                        {{ getReviewerLabel(false) }}
                     </th>-->
                     <th mat-sort-header="reviewType">
                        Review
                        <br />
                        Type
                     </th>
                     <th>
                        Additional
                        <br />
                        Responsibilities
                     </th>
                     <th class="defer-col-header">Defer User?</th>
                  </tr>
               </thead>
               <tbody>
                  <tr *ngIf="dashboardRows.length < 1">
                     <td
                        colspan="9"
                        style="text-align: center">
                        You have no {{ getRevieweeLabel() }}'s' to review
                     </td>
                  </tr>
                  <tr
                     *ngFor="let row of pagedRows; let i = index; trackBy: trackByReviewee"
                     [class.alternate]="i % 2 !== 0"
                     [class.row-deferred]="row._deferred || row._onLeave"
                     [class.row-read-only]="readOnlyMode"
                     style="vertical-align: -webkit-baseline-middle">
                     <td
                        class="team-practice-col"
                        [style.background-color]="row._color.bg"
                        [style.color]="row._color.color"
                        style="border-top: 1px solid; border-bottom: 1px solid; position: relative"
                        [style.border-top-color]="row._color.borderTopColor"
                        [style.border-bottom-color]="row._color.borderBottomColor">
                        {{ row.practice }}
                        <span
                           class="home-hospital"
                           *ngIf="row._isHome">
                           <i class="fas fa-home"></i>
                        </span>
                     </td>

                     <td style="min-width: 205px; max-width: 205px">
                        <div class="name-cell">
                           <div
                              class="av"
                              [style.background]="row._color.bg"
                              [style.color]="row._color.color">
                              {{ row._initials }}
                           </div>
                           {{ row.name }}

                           <span *ngIf="row.hasAttachment">
                              &nbsp;
                              <i
                                 class="fa fa-paperclip"
                                 style="font-size: 12px; color: #505050"></i>
                           </span>
                        </div>

                        <span
                           *ngIf="row._deferred"
                           class="deferred-badge"
                           tooltipstyleclass="pims-tooltip"
                           [pTooltip]="row.deferReason"
                           style="padding-bottom: 1px">
                           <i class="fa fa-clock"></i>
                           Deferred
                        </span>
                        <span
                           *ngIf="row._onLeave"
                           class="deferred-badge">
                           <i class="fa fa-user-alt"></i>
                           On leave
                        </span>
                     </td>

                     <td style="min-width: 100px; padding-right: 5px">
                        {{ row.hireDate | date: "M/d/yyyy" }}
                     </td>

                     <td style="min-width: 90px; max-width: 90px; padding-right: 5px; overflow-wrap: break-word">
                        <span style="color: #a1a1a1">{{ row.jobTitleCode }}</span>
                     </td>

                     <td style="min-width: 105px; max-width: 125px; padding-right: 5px">
                        <span style="color: #232425; font-style: italic">{{ row.jobTitle }}</span>
                     </td>

                     <td style="min-width: 110px; max-width: 110px; padding-right: 5px">
                        <span class="um-role-chip">
                           {{ row._payClassLabel }}
                        </span>
                     </td>

                     <td
                        class="reviewOptions"
                        style="max-width: 170px">
                        <p-dropdown
                           [(ngModel)]="row.reviewType"
                           [options]="teamReviewOptions"
                           [disabled]="row.hasStarted"
                           placeholder="Select Type"
                           ngModelOptions="{standalone: true}"
                           [showClear]="false"
                           (ngModelChange)="onReviewTypeChange($event, row, modals)"
                           name="teamReviewType-{{ row.revieweeId }}"></p-dropdown>
                        <br />
                        <a
                           *ngIf="row.reviewType === 'CROSSTRAINED'"
                           href="javascript:void(0);"
                           title="Edit job descriptions for this review"
                           style="margin-left: 4px; font-size: 11px"
                           (click)="modals.openJobDescDialog(row)">
                           <i
                              class="fas fa-plus"
                              style="font-size: 10px"></i>
                           &nbsp;Add job descriptions
                           <div style="margin-bottom: -12px"></div>
                        </a>
                     </td>

                     <td style="max-width: 160px; min-width: 125px; white-space: nowrap; padding-right: 5px">
                        <a
                           href="javascript:void(0);"
                           (click)="row.hasStarted ? '' : modals.openUserResponsibilitiesDialog(row)"
                           [style.opacity]="row.hasStarted ? '0.45' : ''">
                           Manage Duties &nbsp;
                           <i
                              class="fas fa-user-gear"
                              style="font-size: 13px"></i>
                        </a>
                     </td>

                     <td
                        style="min-width: 165px"
                        class="defer-col"
                        (click)="$event.stopPropagation()">
                        <button
                           *ngIf="!row.deferralStatus || row.deferralStatus == 'ReEnabled' || row.deferralStatus == 'Rejected'"
                           class="defer-btn"
                           style="position: relative; height: 30px"
                           [style.opacity]="!row.reviewType ? '0.55' : ''"
                           [class.defer-btn-rejected]="row.deferralStatus == 'Rejected'"
                           (click)="row.deferralStatus == 'Rejected' ? modals.openRejectedDialog(row) : modals.openUserDeferDialog(row)">
                           <i
                              *ngIf="row.deferralStatus == 'Rejected'"
                              class="fa fa-close"
                              style="margin-right: 5px; margin-top: 2px"></i>
                           {{ row.deferralStatus == "Rejected" ? "Rejected" : "Request Deferral" }}
                           <span
                              *ngIf="row.deferralStatus == 'Rejected'"
                              class="fu-unread-badge">
                              1
                           </span>
                        </button>

                        <a
                           href="javascript:void(0);"
                           *ngIf="row.deferralStatus == 'Rejected'"
                           style="display: block; text-decoration: underline; font-size: 11px; color: #333333"
                           (click)="modals.openUserDeferDialog(row)">
                           Request again?
                        </a>

                        <button
                           *ngIf="(row.hasPendingDeferralRequest || row.deferralStatus == 'Pending') && (!row.hasAdminFollowUp || row._unread < 1)"
                           class="defer-btn defer-btn-requested"
                           [disabled]="true">
                           <i
                              class="fa fa-hourglass"
                              style="font-size: 11px; line-height: 18px"></i>
                           &nbsp; Requested
                        </button>

                        <button
                           *ngIf="(row.hasPendingDeferralRequest || row.deferralStatus == 'Pending') && row.hasAdminFollowUp && row._unread > 0"
                           class="defer-btn defer-btn-followup"
                           style="position: relative"
                           (click)="modals.openUserFollowUpDialog(row)">
                           <i
                              class="fa fa-comments"
                              style="font-size: 11px; line-height: 18px"></i>
                           &nbsp; Add Follow-up
                           <span
                              *ngIf="row._unread > 0"
                              class="fu-unread-badge">
                              {{ row._unread }}
                           </span>
                        </button>

                        <span
                           *ngIf="row.deferralStatus == 'Approved' || row.deferralStatus == 'Deferred'"
                           class="defer-na">
                           —
                        </span>
                     </td>
                  </tr>
               </tbody>
            </table>

            <!-- Pager -->
            <div
               class="table-pager"
               *ngIf="dashboardRows.length > pageSize">
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex === 0"
                  (click)="goToPage(0)"
                  title="First page">
                  <i class="fa fa-angles-left"></i>
               </button>
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex === 0"
                  (click)="goToPage(pageIndex - 1)"
                  title="Previous page">
                  <i class="fa fa-angle-left"></i>
               </button>
               <span class="table-pager__label">
                  Page
                  <input
                     type="number"
                     class="table-pager__input"
                     [value]="pageIndex + 1"
                     [min]="1"
                     [max]="totalPages"
                     (change)="goToPage(+$event.target.value - 1)" />
                  of {{ totalPages }} · {{ pageRangeStart }}–{{ pageRangeEnd }} of {{ dashboardRows.length }}
               </span>
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex >= totalPages - 1"
                  (click)="goToPage(pageIndex + 1)"
                  title="Next page">
                  <i class="fa fa-angle-right"></i>
               </button>
               <button
                  type="button"
                  class="table-pager__btn"
                  [disabled]="pageIndex >= totalPages - 1"
                  (click)="goToPage(totalPages - 1)"
                  title="Last page">
                  <i class="fa fa-angles-right"></i>
               </button>
            </div>
         </div>
      </div>
   </div>

   <button
      type="button"
      class="getting-started-fab"
      *ngIf="activeTeamSubTab === 'roster'"
      (click)="modals.reopenGettingStarted()"
      title="Getting started">
      <i class="fas fa-circle-question"></i>
      &nbsp;Getting started
   </button>

   <div class="progress-fab">
      <dvm-tool-hospital-progress-panel
         *ngIf="isUserReviewsLoaded && isPlansLoaded && activeTeamSubTab === 'roster'"
         [rows]="allRows"
         [userName]="userName"></dvm-tool-hospital-progress-panel>
   </div>

   <dvm-tool-team-dashboard-modals #modals></dvm-tool-team-dashboard-modals>
</div>
